import React, { Component } from 'react';
import './completion-report.scss';
import { ImageConstants, Constants } from '../../../../constants/constants';
import { getImageSource } from '../../../../utility/image-source'
import TestApi from '../../../../apis/test'
import Loading from '../../../common/loading/loading'
import TestResultDetails from '../test-result-details-V2/test-result-details'

class CompletionReport extends Component {

    state = {
        completedStudents: [
        ],
        notCompletedStudents: [
        ]
    }

    // selectedItem = {

    // }

    // constructor(props) {
    //     super(props)


    //     let chaptersList = []

    //     chaptersList.push(this.props.match.params.chapter)


    //     this.selectedItem = {
    //         chapters : chaptersList,
    //         class : this.props.match.params.class,
    //         createdDate : this.props.match.params.createdDate,
    //         _id: this.props.match.params.homeworkId
    //     }

    //     console.log(this.selectedItem)

    // }







    componentDidMount() {
        this.getTestCompletionReport()
    }

    onClickBackList = () => {
        this.props.delegate && this.props.delegate.hideReport && this.props.delegate.hideReport()
    }

    getTestCompletionReport(payload = {}) {

        this.setState({ isLoading: true })

        if (payload.page) payload.page = 1
        if (payload.page) payload.limit = this.limit

        if (this.props.selectedItem) {
            payload.testId = this.props.selectedItem._id
        }

        TestApi.getTestCompletionReport(payload)
            .then(response => {

                // console.log("response", response)
                this.setState({
                    completedStudents: response.completedStudents,
                    inProgressStudents: response.inProgressStudents,
                    notCompletedStudents: response.notCompletedStudents, isLoading: false
                })

            }).catch(err => {
            })
    }

    getChapterNames(chapters) {
        let arr = []
        for (let i = 0; i < chapters.length; i++) {
            arr.push(chapters[i].title)
        }
        return arr.join(", ")
    }

    renderBreadcrumb = () => {
        return (
            <div className='breadcrumb-1'>
                <span>{`${this.props.selectedItem?.class || ""} >`}</span>
                <span className='pl-2'>{`${this.props.selectedItem?.section || ""} >`}</span>
                <span className='pl-2'>{this.getChapterNames(this.props.selectedItem?.chapters)} {`>`} </span>
                <span className='pl-2'>{this.getDate(this.props.selectedItem?.createdDateTimestamp)}</span>
            </div>
        )
    }

    getDate = (timeStamp, getYear) => {

        let dateFormat = new Date(timeStamp).toDateString();

        let date = dateFormat.split(" ")[2];

        let month = dateFormat.split(" ")[1];

        let year = dateFormat.split(" ")[3];

        if (getYear) {
            return date + " " + month + " " + year;
        } else {
            return date + " " + month;
        }
    }

    List = () => {
        this.props.delegate && this.props.delegate.hideTestResultsReport && this.props.delegate.hideTestResultsReport()
    }

    showTestResultDetailsReport = (item) => {
        // if (type == 'Details') {
        this.setState({ showTestResultDetailReport: true, selectedAction: 'ResultDetails', selectedStudent: item })
        // }
        // else if (type == 'AnswerSheet') {
        //     this.setState({ showTestResultDetailReport: true, selectedAction: 'AnswerSheet' })
        // }

    }

    hideTestResultDetailsReport = () => {
        this.setState({ showTestResultDetailReport: false })
    }

    onClickBack = () => {
        this.props.delegate && this.props.delegate.hideCompletionReport && this.props.delegate.hideCompletionReport()
    }


    render() {

        if (this.state.showTestResultDetailReport) {
            return <TestResultDetails delegate={this}
                student={this.state.selectedStudent}
                selectedItem={this.props.selectedItem}
                selectedAction={this.state.selectedAction} />
        }

        return (
            <>
                {this.state.isLoading && <div ><Loading> </Loading></div>}
                <div className='test-completion-report'>
                    {/* <div className='mb-5'>
                        <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBackList()} />
                    </div> */}

                    {/* <div className='container-1 mb-2'>
                        <div className=' item1 mt-2'>
                            <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                        </div>
                        <div className='item-2'>
                            <span className='screen-title title-center my-5'>Assessment Completion Report</span>
                        </div>
                    </div>

                    <span>{this.renderBreadcrumb()}</span> */}
                    <div className=' item1 mb-3'>
                        <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                    </div>
                    <div className='d-flex align-items-center justify-content-between header-report-card mb-3'>
                        <div className='d-flex align-items-center'>
                            <div>
                                <img className='circle-image' src={getImageSource(ImageConstants.COMPLETION_DETAIL_REPORT)} />
                            </div>
                            <div className='ml-2'>
                                <div className=''>
                                    <span className='screen-title-1'>Completion Report</span>
                                    <span>{this.renderBreadcrumb()}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="pt-4 wrapper ml-4">
                        <div class="report-card border-green d-inline-block">
                            <div class="report-header background-green"><div>Completed ({this.state.completedStudents && this.state.completedStudents.length ? this.state.completedStudents.length : 0})</div></div>
                            <div className="report-body">
                                {
                                    this.state.completedStudents && this.state.completedStudents.length ? this.state.completedStudents.map(student => (
                                        <div className="py-3">
                                            <div className="row">
                                                {/* <div className="col-2">
                                                                        <div className="profile-avatar text-center mr-2 d-inline-block">
                                                                            <div className="row justify-content-center">
                                                                                {student.image ? <img className="" alt="img" src={`${student.basePath}${student.image}`} />
                                                                                    :
                                                                                    <img className="" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                                                                            </div>
                                                                        </div>
                                                                    </div> */}
                                                <div className="col-9">
                                                    <div className="pl-2 d-inline-block">
                                                        <div className="student-name">{student?.name}</div>
                                                        <div className="student-mark">Marks: {student.mark}</div>
                                                    </div>
                                                </div>
                                                <div className="col-1 my-auto">
                                                    <img className='icon-size cursor-pointer' src={getImageSource(ImageConstants.MENU_ICON)} onClick={() => this.showTestResultDetailsReport(student)} />
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                        :
                                        <div className="no-data text-center">
                                            <img className="" src={getImageSource(ImageConstants.NO_DATA)} />
                                            <div className="empty">This is Empty</div>
                                            <div className="no-student">No Student in this bucket</div>
                                        </div>
                                }

                            </div>
                        </div>
                        <div class="report-card border-green d-inline-block ml-4">
                            <div class="report-header background-green"><div>Inprogress ({this.state.inProgressStudents && this.state.inProgressStudents.length ? this.state.inProgressStudents.length : 0})</div></div>
                            <div className="report-body">
                                {
                                    this.state.inProgressStudents && this.state.inProgressStudents.length ? this.state.inProgressStudents.map(student => (
                                        <div className="py-3">
                                            <div className="row">
                                                {/* <div className="col-2">
                                                                        <div className="profile-avatar text-center mr-2 d-inline-block">
                                                                            <div className="row justify-content-center">
                                                                                {student.image ? <img className="" alt="img" src={`${student.basePath}${student.image}`} />
                                                                                    :
                                                                                    <img className="" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                                                                            </div>
                                                                        </div>
                                                                    </div> */}
                                                <div className="col-9">
                                                    <div className="pl-2 d-inline-block">
                                                        <div className="student-name">{student?.name}</div>
                                                        <div className="student-mark">Marks: {student.mark}</div>
                                                    </div>
                                                </div>
                                                <div className="col-1 my-auto">
                                                    <img className='icon-size cursor-pointer' src={getImageSource(ImageConstants.MENU_ICON)} onClick={() => this.showTestResultDetailsReport(student)} />
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                        :
                                        <div className="no-data text-center">
                                            <img className="" src={getImageSource(ImageConstants.NO_DATA)} />
                                            <div className="empty">This is Empty</div>
                                            <div className="no-student">No Student in this bucket</div>
                                        </div>
                                }

                            </div>
                        </div>
                        <div className="report-card border-red d-inline-block ml-4">
                            <div class="">
                                <div class="report-header background-red"><div>Not Completed ({this.state.notCompletedStudents && this.state.notCompletedStudents.length ? this.state.notCompletedStudents.length : 0})</div></div>
                                <div className="report-body">
                                    {
                                        this.state.notCompletedStudents && this.state.notCompletedStudents.length ? this.state.notCompletedStudents.map(student => (
                                            <div className="py-3">
                                                <div className="flex">
                                                    {/* <div className="profile-avatar text-center mr-2 d-inline-block">
                                                                                                    <div className="row justify-content-center">
                                                                                                        {student.image ? <img className="" alt="img" src={`${student.basePath}${student.image}`} />
                                                                                                            :
                                                                                                            <img className="" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                                                                                                    </div>
                                                                                                </div> */}
                                                    <div className="pl-2 d-inline-block">
                                                        <div className="student-name">{student?.name}</div>
                                                        {/* <div className="student-mark">Marks: {student.mark}</div> */}
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                            :
                                            <div className="no-data text-center">
                                                <img className="" src={getImageSource(ImageConstants.NO_DATA)} />
                                                <div className="empty">This is Empty</div>
                                                <div className="no-student">No Student in this bucket</div>
                                            </div>
                                    }

                                </div>
                            </div>
                        </div>
                    </div >
                </div>
            </>
        );
    }
}

export default CompletionReport;